const ImportExport = ({ size = 24, color = "var(--primary-text-color)" }) => {
    return (
        <svg 
            xmlns="http://www.w3.org/2000/svg" 
            height={`${size}px`}
            width={`${size}px`}
            viewBox="0 -960 960 960" 
            fill={color}
        >
            <path d="M240-160v-80h480v80H240Zm240-200L280-600l56-56 104 104v-328h80v328l104-104 56 56-200 200Z" />
        </svg>
    )
}

export default ImportExport; 